import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {api} from "../../../res/rest/api";
import Platform from "../../logic/platform/platform";
import {request} from "../../../res/rest/restRequest";

const updateOrderLine = async (session, cartItem) => {
    const updateData = {
        "QtyEntered": cartItem.qtyEntered,
        "QtyOrdered": cartItem.qtyOrdered,
        "C_UOM_ID": {
            "id": cartItem.uomID,
        }
    }

    if(cartItem.isBackOrdered) {
        updateData["isbackorder"] = 'true';
    }

    if(cartItem.asiID > 0) {
        updateData["M_AttributeSetInstance_ID"] = {
            "id": cartItem.asiID
        }
    }

    const url = request.model("c_orderline")
        .id(cartItem.orderLineID)
        .buildRequest(env.API_URL);
    const response = await HttpClient.client.put(url, updateData, api.auth(session));

    const line = response.data;
    if(line.M_AttributeSetInstance_ID && line.M_AttributeSetInstance_ID.id > 0) {
        line.M_AttributeSetInstance_ID = { id: cartItem.asiID };
    }
    return response.data;
}

const createOrderLine = async (session, cartItem, orderID) => {
    const lineData = {
        "C_Order_ID": {
            "id": orderID,
        },
        "M_Product_ID": {
            "id": cartItem.productID,
        },
        "C_UOM_ID": {
            "propertyLabel": "UOM",
            "id": cartItem.uomID,
            "model-name": "c_uom"
        },
        "M_Warehouse_ID": {
            "propertyLabel": "Warehouse",
            "id": 1000000,
            "identifier": "Standard",
            "model-name": "m_warehouse"
        },
        "QtyEntered": cartItem.qtyEntered,
        "QtyOrdered": cartItem.qtyOrdered,
    }

    if(Platform.isMobile()) {
        lineData['X_SO_Origin'] = Platform.isIos() ? 'IOS' : 'A';
    } else {
        lineData['X_SO_Origin'] = 'W';
    }

    if(cartItem.isBackOrdered) {
        lineData["isbackorder"] = 'true';
    }

    if(cartItem.asiID > 0) {
        lineData["M_AttributeSetInstance_ID"] = {
            "id": cartItem.asiID
        }
    }

    const url = request.model("c_orderline")
        .buildRequest(env.API_URL);
    const response =  await HttpClient.client.post(url, lineData, api.auth(session));

    if(cartItem.asiID > 0) {
        response.data.M_AttributeSetInstance_ID.id = cartItem.asiID;
    }

    return response.data;
}

const deleteOrderLine = async (session, orderLineID) => {
    const url = request.model("c_orderline")
        .id(orderLineID)
        .buildRequest(env.API_URL);
    return HttpClient.client.delete(url, api.auth(session));
}

const syncOrderLineRequest = async (session, cartItem, orderID) => {
    if(cartItem.orderLineID === 0) {
        const res = await createOrderLine(session, cartItem, orderID);
        res["M_Product_ID"] = cartItem.product;
        return {deleted: false, ol:res};
    } else if(cartItem.qtyEntered > 0) {
        const res = await updateOrderLine(session, cartItem);
        res["M_Product_ID"] = cartItem.product;
        return {deleted: false, ol:res};
    } else {
        await deleteOrderLine(session, cartItem.orderLineID);
        return {deleted: true, olID: cartItem.orderLineID};
    }
}

export default syncOrderLineRequest;